import axios from "axios";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import EstablishmentprofileData from "../../../components/rh/establishmentprofiles/EstablishmentprofileData";
import DaystaffForm from "../../../components/rh/daystaffs/Daystaff";
import StaffForm from "./StaffForm";
import LessonStaff from "./LessonStaff";
import Listprint from "../../Listprint";
import Profile from "../profiles/Profile";
class Staff extends Component {
  state = {
    isModal: false,
    loading: true,
    loadError: "",
    profileModal: false,
    isModalProfile: false,
    isModalDayuser: false,
    user: "",
    userprofile: "",
    formData: "",
    viewMode: "cards",
    search: "",
    staffs: [],
    staffId: null,
    columns: [
      { label: "Personnel", field: "staff", sort: "asc", width: 230 },
      { label: "Matricule", field: "matricule", sort: "asc", width: 110 },
      { label: "Coordonnées", field: "contact", sort: "asc", width: 190 },
      { label: "Identité", field: "identity", sort: "asc", width: 145 },
      { label: "Engagement", field: "commitment", sort: "asc", width: 140 },
      { label: "Fonctions", field: "profile", sort: "asc", width: 190 },
      {
        label: "",
        field: "actions",
        sort: "disabled",
        width: 120,
        printable: false,
      },
    ],
  };
  componentDidMount() {
    this.getStaffs();
  }
  getStaffs = async () => {
    this.setState({ loading: true, loadError: "" });
    try {
      const r = await axios.get("staffs");
      this.setState({ staffs: Array.isArray(r.data) ? r.data : [] });
    } catch (e) {
      this.setState({
        loadError: "Impossible de charger le registre du personnel.",
      });
    } finally {
      this.setState({ loading: false });
    }
  };
  showModal = (staff = null) =>
    this.setState(
      (s) => ({ isModal: !s.isModal, formData: s.isModal ? "" : staff }),
      () => {
        if (!this.state.isModal) this.getStaffs();
      },
    );
  delete = async (staff) => {
    const name =
      this.getName(staff) || staff.matricule || "ce membre du personnel";
    if (!window.confirm(`Supprimer définitivement « ${name} » ?`)) return;
    try {
      const r = await axios.delete(`staffs/${staff.id}`);
      toast.success(r?.data?.msg || "Le membre du personnel a été supprimé.");
      this.getStaffs();
    } catch (e) {
      toast.error(e.response?.data?.msg || "La suppression a échoué.");
    }
  };
  showModalProfile = (userprofile = null, user = null) =>
    this.setState(
      (s) => ({ isModalProfile: !s.isModalProfile, userprofile, user }),
      () => {
        if (!this.state.isModalProfile) this.getStaffs();
      },
    );
  showModalDayuser = (staff = null) =>
    this.setState((s) => ({
      staffId: staff,
      isModalDayuser: !s.isModalDayuser,
    }));
  can = (permission) => {
    try {
      return JSON.parse(localStorage.getItem("permissions") || "[]").some(
        (i) => permission === i.permission,
      );
    } catch (e) {
      return false;
    }
  };
  getName = (staff) => {
    const u = staff?.user || {};
    return [u.last_name, u.family_name, u.first_name]
      .filter(Boolean)
      .join(" ")
      .trim();
  };
  getInitials = (staff) =>
    this.getName(staff)
      .split(/\s+/)
      .slice(0, 2)
      .map((p) => p.charAt(0))
      .join("")
      .toUpperCase() || "RH";
  profiles = (staff) =>
    (staff?.user?.userprofiles || []).filter(
      (p) => Number(p.status) === 1 && p.profile,
    );
  date = (value) => {
    if (!value) return "";
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? "" : d.toLocaleDateString("fr-FR");
  };
  matches = (staff, q) => {
    if (!q) return true;
    const u = staff.user || {};
    return [
      this.getName(staff),
      staff.matricule,
      u.identity_number,
      u.tel,
      u.email,
      u.genre,
      u.nationality,
      ...this.profiles(staff).map((p) => p.profile?.profile),
    ]
      .filter(Boolean)
      .some((v) => String(v).toLocaleLowerCase("fr").includes(q));
  };
  rows = (staffs) =>
    staffs.map((s) => {
      const u = s.user || {},
        name = this.getName(s) || "Personnel sans nom",
        profiles = this.profiles(s);
      return {
        staff: (
          <Link to={`/staffs/${s.id}`} className="staff-table-person">
            <span className="staff-table-avatar">
              {u.avatar ? (
                <img
                  src={u.avatar}
                  alt=""
                  onError={(e) => {
                    e.currentTarget.style.display = "none";
                    e.currentTarget.nextElementSibling.style.display = "grid";
                  }}
                />
              ) : null}
              <i style={u.avatar ? { display: "none" } : undefined}>
                {this.getInitials(s)}
              </i>
            </span>
            <span>
              <b>{name}</b>
              <small>
                {u.identity_number
                  ? `Pièce n° ${u.identity_number}`
                  : "Identité à compléter"}
              </small>
            </span>
          </Link>
        ),
        matricule: (
          <Link to={`/staffs/${s.id}`} className="staff-table-matricule">
            {s.matricule || "Non attribué"}
          </Link>
        ),
        contact: (
          <span className="staff-table-contact">
            {u.tel ? (
              <a href={`tel:${u.tel}`}>
                <FeatherIcon icon="phone" size={13} />
                {u.tel}
              </a>
            ) : (
              <em>Téléphone absent</em>
            )}
            {u.email ? (
              <a href={`mailto:${u.email}`}>
                <FeatherIcon icon="mail" size={13} />
                {u.email}
              </a>
            ) : (
              <em>E-mail absent</em>
            )}
          </span>
        ),
        identity: (
          <span className="staff-table-identity">
            <b>{u.genre || "Genre non précisé"}</b>
            <small>{u.nationality || "Nationalité non précisée"}</small>
          </span>
        ),
        commitment: (
          <span className="staff-table-identity">
            <b>{this.date(s.commitment_date) || "Non daté"}</b>
            <small>
              {s.seniority
                ? `${s.seniority} d’ancienneté`
                : "Ancienneté non précisée"}
            </small>
          </span>
        ),
        profile: (
          <span className="staff-table-roles">
            {profiles.length ? (
              profiles.map((p) => (
                <span key={p.id || p.profile?.id}>{p.profile.profile}</span>
              ))
            ) : (
              <em>Aucune fonction</em>
            )}
          </span>
        ),
        actions: (
          <span className="staff-table-actions">
            <button
              type="button"
              onClick={() => this.showModalDayuser(s)}
              title={`Horaire de ${name}`}
            >
              <FeatherIcon icon="clock" size={15} />
            </button>
            {this.can("Modifier personnel") && (
              <button
                type="button"
                onClick={() => this.showModal(s)}
                title={`Modifier ${name}`}
              >
                <FeatherIcon icon="edit-3" size={15} />
              </button>
            )}
            {this.can("Supprimer personnel") && (
              <button
                type="button"
                className="danger"
                onClick={() => this.delete(s)}
                title={`Supprimer ${name}`}
              >
                <FeatherIcon icon="trash-2" size={15} />
              </button>
            )}
          </span>
        ),
      };
    });
  renderCard = (staff) => {
    const u = staff.user || {},
      name = this.getName(staff) || "Personnel sans nom",
      profiles = this.profiles(staff),
      viewProfiles = this.can("Afficher profil");
    return (
      <div className="col-sm-6 col-xl-4" key={staff.id}>
        <article className="staff-card">
          <div className="staff-card__identity">
            <Link
              to={`/staffs/${staff.id}`}
              className="staff-avatar"
              aria-label={`Ouvrir ${name}`}
            >
              {u.avatar ? (
                <img
                  src={u.avatar}
                  alt=""
                  onError={(e) => {
                    e.currentTarget.style.display = "none";
                    e.currentTarget.nextElementSibling.style.display = "grid";
                  }}
                />
              ) : null}
              <span style={u.avatar ? { display: "none" } : undefined}>
                {this.getInitials(staff)}
              </span>
            </Link>
            <div className="staff-card__heading">
              <small>{staff.matricule || "Matricule non renseigné"}</small>
              <h3>
                <Link to={`/staffs/${staff.id}`}>{name}</Link>
              </h3>
              <p>
                {u.identity_number
                  ? `Pièce n° ${u.identity_number}`
                  : "Identité à compléter"}
              </p>
            </div>
            <span className="staff-card__status">
              <i />
              Actif
            </span>
          </div>
          <div className="staff-card__contact">
            {u.tel ? (
              <a href={`tel:${u.tel}`}>
                <FeatherIcon icon="phone" size={15} />
                <span>{u.tel}</span>
              </a>
            ) : (
              <span>
                <FeatherIcon icon="phone-off" size={15} />
                <em>Téléphone non renseigné</em>
              </span>
            )}
            {u.email ? (
              <a href={`mailto:${u.email}`}>
                <FeatherIcon icon="mail" size={15} />
                <span>{u.email}</span>
              </a>
            ) : (
              <span>
                <FeatherIcon icon="mail" size={15} />
                <em>E-mail non renseigné</em>
              </span>
            )}
          </div>
          <div className="staff-card__meta">
            <span>
              <FeatherIcon icon="user" size={14} />
              {u.genre || "Genre non précisé"}
            </span>
            <span>
              <FeatherIcon icon="calendar" size={14} />
              {this.date(staff.commitment_date) || "Engagement non daté"}
            </span>
          </div>
          <div className="staff-card__roles">
            <small>Fonctions</small>
            <div>
              {profiles.length ? (
                profiles.map((p) =>
                  viewProfiles ? (
                    <button
                      type="button"
                      key={p.id || p.profile?.id}
                      onClick={() => this.showModalProfile(p, u)}
                    >
                      {p.profile.profile}
                    </button>
                  ) : (
                    <span key={p.id || p.profile?.id}>{p.profile.profile}</span>
                  ),
                )
              ) : (
                <em>Aucune fonction active</em>
              )}
            </div>
          </div>
          <div className="staff-card__footer">
            <button
              type="button"
              className="staff-schedule"
              onClick={() => this.showModalDayuser(staff)}
            >
              <FeatherIcon icon="clock" size={15} />
              Horaire hebdomadaire
            </button>
            <div>
              {this.can("Modifier personnel") && (
                <button
                  type="button"
                  onClick={() => this.showModal(staff)}
                  title={`Modifier ${name}`}
                >
                  <FeatherIcon icon="edit-3" size={15} />
                </button>
              )}
              {this.can("Supprimer personnel") && (
                <button
                  type="button"
                  className="danger"
                  onClick={() => this.delete(staff)}
                  title={`Supprimer ${name}`}
                >
                  <FeatherIcon icon="trash-2" size={15} />
                </button>
              )}
            </div>
          </div>
        </article>
      </div>
    );
  };

  render() {
    const q = this.state.search.trim().toLocaleLowerCase("fr"),
      staffs = [...this.state.staffs]
        .sort((a, b) => this.getName(a).localeCompare(this.getName(b), "fr"))
        .filter((s) => this.matches(s, q));
    const roles = new Set(
        this.state.staffs.flatMap((s) =>
          this.profiles(s).map((p) => p.profile?.id || p.profile?.profile),
        ),
      ).size,
      contacts = this.state.staffs.filter(
        (s) => s.user?.tel || s.user?.email,
      ).length,
      women = this.state.staffs.filter((s) =>
        ["f", "féminin", "feminin", "female"].includes(
          String(s.user?.genre || "").toLocaleLowerCase("fr"),
        ),
      ).length;
    return (
      <main className="container staff-page">
        <Helmet>
          <title>{process.env.REACT_APP_NAME} | Personnel</title>
        </Helmet>
        <header className="staff-header">
          <div>
            <span>
              <FeatherIcon icon="briefcase" size={14} />
              Ressources humaines
            </span>
            <h1>Registre du personnel</h1>
            <p>
              Centralisez les identités, fonctions, coordonnées et horaires de
              votre équipe.
            </p>
          </div>
          <nav>
            <Link to="/manuel#staffs">
              <FeatherIcon icon="book-open" size={17} />
              Doc
            </Link>
            {this.can("Ajouter personnel") && (
              <button type="button" onClick={() => this.showModal()}>
                <FeatherIcon icon="user-plus" size={18} />
                Nouveau personnel
              </button>
            )}
          </nav>
        </header>
        <section className="staff-stats" aria-label="Résumé">
          <article>
            <i>
              <FeatherIcon icon="users" />
            </i>
            <b>
              {this.state.staffs.length}
              <small>Membres enregistrés</small>
            </b>
          </article>
          <article>
            <i>
              <FeatherIcon icon="award" />
            </i>
            <b>
              {roles}
              <small>Fonctions actives</small>
            </b>
          </article>
          <article>
            <i>
              <FeatherIcon icon="phone-call" />
            </i>
            <b>
              {contacts}
              <small>Contacts disponibles</small>
            </b>
          </article>
          <article>
            <i>
              <FeatherIcon icon="user-check" />
            </i>
            <b>
              {women}
              <small>Femmes dans l’équipe</small>
            </b>
          </article>
        </section>
        {this.state.profileModal ? (
          <section className="staff-panel">
            <div className="staff-panel-title">
              <div>
                <span>Administration</span>
                <h2>Profils et permissions</h2>
              </div>
              <button
                type="button"
                onClick={() => this.setState({ profileModal: false })}
              >
                <FeatherIcon icon="x" size={15} />
                Fermer
              </button>
            </div>
            <Profile model="Staff" />
          </section>
        ) : (
          <section className="staff-panel">
            <div className="staff-toolbar">
              <div>
                <span>Annuaire interne</span>
                <h2>Membres du personnel</h2>
              </div>
              <label>
                <FeatherIcon icon="search" size={16} />
                <input
                  type="search"
                  value={this.state.search}
                  onChange={(e) => this.setState({ search: e.target.value })}
                  placeholder="Nom, matricule, fonction…"
                />
                {this.state.search && (
                  <button
                    type="button"
                    onClick={() => this.setState({ search: "" })}
                  >
                    <FeatherIcon icon="x" size={14} />
                  </button>
                )}
              </label>
              <div className="staff-switch">
                <button
                  className={this.state.viewMode === "cards" ? "active" : ""}
                  onClick={() => this.setState({ viewMode: "cards" })}
                >
                  <FeatherIcon icon="grid" size={16} />
                </button>
                <button
                  className={this.state.viewMode === "list" ? "active" : ""}
                  onClick={() => this.setState({ viewMode: "list" })}
                >
                  <FeatherIcon icon="list" size={16} />
                </button>
              </div>
              {this.can("Afficher profil") && (
                <button
                  className="staff-profiles"
                  onClick={() => this.setState({ profileModal: true })}
                >
                  <FeatherIcon icon="shield" size={16} />
                  Profils
                </button>
              )}
            </div>
            {this.state.loading ? (
              <div className="staff-state">
                <FeatherIcon className="user-search-spin" icon="loader" />
              </div>
            ) : this.state.loadError ? (
              <div className="staff-state error">
                <FeatherIcon icon="alert-circle" />
                <h3>Registre indisponible</h3>
                <p>{this.state.loadError}</p>
                <button onClick={this.getStaffs}>Réessayer</button>
              </div>
            ) : staffs.length ? (
              this.state.viewMode === "cards" ? (
                <div className="row g-3">{staffs.map(this.renderCard)}</div>
              ) : (
                <div className="staff-list">
                  <Listprint
                    rows={this.rows(staffs)}
                    columns={this.state.columns}
                    title="MISE EN PLACE DU PERSONNEL ENSEIGNANT ET ADMINISTRATIF"
                  />
                </div>
              )
            ) : (
              <div className="staff-state">
                <FeatherIcon icon={q ? "search" : "users"} />
                <h3>{q ? "Aucun résultat" : "Le registre est vide"}</h3>
                <p>
                  {q
                    ? "Essayez un autre nom, matricule ou intitulé de fonction."
                    : "Ajoutez un premier membre pour constituer l’annuaire."}
                </p>
              </div>
            )}
          </section>
        )}
        {!this.state.loading &&
          !this.state.loadError &&
          this.state.staffs.length > 0 && (
            <section className="staff-panel staff-lessons">
              <div className="staff-panel-title">
                <i>
                  <FeatherIcon icon="bar-chart-2" size={18} />
                </i>
                <div>
                  <span>Charge pédagogique</span>
                  <h2>Statistique des cours par membre</h2>
                </div>
              </div>
              <LessonStaff title="Statistique des cours par personnel" />
            </section>
          )}
        <StaffForm
          isModal={this.state.isModal}
          formData={this.state.formData}
          showModal={this.showModal}
        />
        {this.state.staffId && this.state.isModalDayuser && (
          <DaystaffForm
            staffId={this.state.staffId.id}
            staffName={this.getName(this.state.staffId)}
            isModal={this.state.isModalDayuser}
            showModal={this.showModalDayuser}
          />
        )}
        <EstablishmentprofileData
          isModal={this.state.isModalProfile}
          formData={this.state.userprofile}
          fromUser={this.state.user}
          showModal={this.showModalProfile}
        />
      </main>
    );
  }
}
export default Staff;
